module.exports = __webpack_public_path__ + "static/media/user.5bbd52fd.svg";